import type { TicketComment } from '../../types/ticket.types';

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

export function CommentThread({ comments }: { comments: TicketComment[] }) {
  if (comments.length === 0) {
    return (
      <div className="text-center py-8 text-ems-text-muted text-sm">
        No comments yet. Start the conversation below.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {comments.map(comment => (
        <div
          key={comment.comment_id}
          className={`rounded-lg p-4 ${
            comment.source === 'system'
              ? 'bg-ems-bg/50 border border-ems-border'
              : 'bg-ems-bg-card-hover border border-ems-border'
          }`}
        >
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-ems-green/15 flex items-center justify-center">
                <span className="text-xs font-semibold text-ems-green">
                  {comment.author_name?.charAt(0)?.toUpperCase() || '?'}
                </span>
              </div>
              <span className="text-sm font-medium text-ems-text-primary">{comment.author_name}</span>
              {comment.source === 'system' && (
                <span className="text-xs bg-slate-500/20 text-slate-400 px-1.5 py-0.5 rounded font-medium">
                  System
                </span>
              )}
            </div>
            <span className="text-xs text-ems-text-muted">{formatDate(comment.created_at)}</span>
          </div>
          <div className="text-sm text-ems-text-secondary leading-relaxed whitespace-pre-wrap pl-9">
            {comment.body}
          </div>
        </div>
      ))}
    </div>
  );
}
